function VideoScreen() {
  return <div>VideoScreen</div>;
}

export default VideoScreen;
